__turbopack_context__.v({
  "closeButton": "FullSearchPanel-module-scss-module__ERw7pG__closeButton",
  "content": "FullSearchPanel-module-scss-module__ERw7pG__content",
  "divider": "FullSearchPanel-module-scss-module__ERw7pG__divider",
  "header": "FullSearchPanel-module-scss-module__ERw7pG__header",
  "inputSection": "FullSearchPanel-module-scss-module__ERw7pG__inputSection",
  "mt1": "FullSearchPanel-module-scss-module__ERw7pG__mt1",
  "root": "FullSearchPanel-module-scss-module__ERw7pG__root",
  "title": "FullSearchPanel-module-scss-module__ERw7pG__title",
  "top": "FullSearchPanel-module-scss-module__ERw7pG__top",
});
